import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { SpinnerService } from 'src/app/services/spinner.service';
import { setConfigTable, setConfigTableModalBusqueda,timerOut } from 'src/app/shared/utils';
import { TableFunctionService } from 'src/app/services/table-function.service';

@Component({
  selector: 'app-modal-busqueda-codclaart',
  templateUrl: './modal-busqueda-codclaart.component.html',
  styleUrls: ['./modal-busqueda-codclaart.component.css']
})
export class ModalBusquedaCodclaartComponent implements OnInit {

  @Input() clasesCodigos: [];

  dtTrigger: Subject<null> = new Subject();
  dtOptions: any = {};
  position: number = 1;
  index: number = 0;
  lsttemp

  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  constructor(
    private modalService: NgbActiveModal, 
    private spinnerService: SpinnerService,
    private chRef: ChangeDetectorRef,
    private tableFunction: TableFunctionService,

  ) { };

  ngOnInit(): void {

    this.position = 0;
    this.index = this.clasesCodigos.length - 1;
    this.lsttemp = this.clasesCodigos[this.position]

    this.dtOptions = setConfigTableModalBusqueda(false);
    timerOut(10).then((value: any) => {
      if (value) { this.codArticuloInput.nativeElement.focus(); }
    });
    setTimeout(() => {
      this.spinnerService.activarLoading(false);
    }, 500);

    this.tableFunction.destruirTabla('datatableArtCodCla');
    this.construirTabla('datatableArtCodCla');

  }
  construirTabla(idTable: string) {
    this.chRef.detectChanges();
    this.tableFunction.createTable(idTable, true, true, '60vh', true);
  }
  onClick(data: any): void {
    this.modalService.close(data);
  }

  cancelar(): void {
    this.modalService.dismiss('canceling');
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    let x = event.keyCode;

    if (this.clasesCodigos.length > 0) {
      if (x === 13) {//enter 13
        this.onClick(this.clasesCodigos[this.position])
        this.lsttemp = this.clasesCodigos[this.position]
      }

      if (x === 38) {//38 arriba
        if (this.position > 0) {
          this.position--;
          this.lsttemp = this.clasesCodigos[this.position]
        }
      }

      if (x === 40) {//40 abajo
        if (this.position < this.index) {
          this.position++;
          this.lsttemp = this.clasesCodigos[this.position]
        }
      }
    }
  }
  @ViewChild('codArticuloI') codArticuloInput: ElementRef;

  onNexFocus() {
    timerOut(10).then((value: any) => {
      if (value) { this.codArticuloInput.nativeElement.focus(); }
    });
  }

}
